import React, {Component} from 'react'

import {colors} from "../../utils/styles"
import {formatNumber, merge} from "../../utils/util"

export class DndChargesRenderer extends Component {

  constructor(props) {
    super(props)
    this.state = this.extractStateFromProps(props)
  }

  extractStateFromProps(props) {
    const {currency, message, loading, originalTargetPickupDt, targetPickupDt, scenario} = props.data
    const isPUDateChanged = scenario === 'CHANGE TO'
        && targetPickupDt && originalTargetPickupDt !== targetPickupDt
    return {value: props.value, currency, message, loading, isPUDateChanged}
  }

  render() {
    let gridStyle = {gridTemplateColumns: 'max-content max-content', display: 'grid', gridColumnGap: '5px'}
    if (this.state.isPUDateChanged) {
      gridStyle = merge(gridStyle, {color: colors.dataChanged})
    }
    if (this.state.message) {
      return <span
          style={{fontWeight: 600, whiteSpace: 'normal', color: colors.red}}>{this.state.message}</span>
    }
    if (this.state.loading) {
      return <img src="images/loading2.gif" style={{paddingLeft: 50, height: 25}}/>
    }
    return (
        <div className="grid-container"
             style={gridStyle}>
          <div className="grid-item" style={{textAlign: 'end'}}>{formatNumber(this.state.value)}</div>
          <div className="grid-item">{this.state.currency}</div>
        </div>
    )
  }

  refresh(props) {
    this.setState(this.extractStateFromProps(props))
    return true
  }
}

export default DndChargesRenderer